<div class="rsr-badge" [class]="variant()">
  @if ($icon()) {
    <mat-icon>{{$icon()}}</mat-icon>
  }
  <div class="badge__content">
    <ng-content></ng-content>
  </div>
</div>

